export default __webpack_public_path__ + "static/media/image5.5bcf9d25.jpg";